import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch } from "react-redux";

import { BILLING_TAB_VIEW_MAPPER } from "static/constants";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import Insurances from "containers/Insurances/insurances";
import ReferringProviders from "containers/ReferringProviders/ReferringProviders";
import CustomTabs from "components/common/tabs/CustomTabs";

const Billing = () => {
  const navigate = useNavigate();
  const { view } = useParams();
  const dispatch = useDispatch();

  const [tabView, setTabView] = useState(null);

  const onTabChange = (newValue) => {
    navigate(`/billing/${newValue}`);
    setTabView(newValue);
  };

  useEffect(() => {
    if (view !== tabView) {
      setTabView(view || "insurances");
    }
  }, [view]);

  useEffect(() => {
    const pageTitle = BILLING_TAB_VIEW_MAPPER[tabView];

    dispatch(
      setTitle({
        title: pageTitle,
      })
    );
  }, [tabView]);

  const tabs = [
    {
      label: "Insurances",
      value: "insurances",
      component: <Insurances />,
    },
    {
      label: "Referring Providers",
      value: "referring-providers",
      component: <ReferringProviders />,
    },
  ];

  return (
    <CustomTabs tabs={tabs} selectedTab={tabView} onChange={onTabChange} />
  );
};

export default Billing;
